import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import ls from "util/secureStorage";
import constant from "config/constant";
import { wrapBaseApi } from "util/apiWrapper";

// console.log("AUTH HEADER", _headers);

// Define a service using a base URL and expected endpoints
export const bankApi = createApi({
  reducerPath: "bank",
  // refetchOnReconnect: true,
  refetchOnMountOrArgChange: true,
  tagTypes: ["BanksByCountry", "BanksDetails", "Level2Status"],
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_WALLET_API_ENDPOINT}`,
    prepareHeaders: (headers, _) => {
      const auth = ls.get(constant.AUTH_TOKEN_KEY);

      headers.set("Authorization", auth?.token);
      headers.set("Content-Type", "application/json");
      headers.set("Cache-Control", "no-cache, no-store, must-revalidate");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getBanksByCountry: builder.query({
      query: (country) => wrapBaseApi(`/banks?country=${country}`),
      transformResponse: (res) => res?.data,
      providesTags: ["BanksByCountry"],
    }),
    getBanksDetails: builder.query({
      query: () => wrapBaseApi(`/account/getBankDetails`),
      transformResponse: (res) => res?.data?.bank,
      providesTags: ["BanksDetails"],
      keepUnusedDataFor: 2,
      refetchOnFocus: true,
    }),
    getLevel2Status: builder.query({
      query: () => wrapBaseApi(`/verification/upload`),
      transformResponse: (res) => res?.data?.documents,
      providesTags: ["Level2Status"],
    }),

    resolveAccount: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/banks/resolve`),
        method: "POST",
        body: input,
      }),
      transformResponse: (res) => res?.data?.resolved,
    }),
    addBank: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/account/addBankDetails`),
        method: "POST",
        body: input,
      }),
      transformResponse: (res) => res,
      invalidatesTags: ["BanksDetails"],
    }),
    deleteBank: builder.mutation({
      query: (id) => ({
        url: wrapBaseApi(`/account/deleteBankDetails/${id}`),
        method: "DELETE",
      }),
      transformResponse: (res) => res,
      invalidatesTags: ["BanksDetails"],
    }),
    withdraw: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/wallet/withdrawal/fiat`),
        method: "POST",
        body: input,
      }),
      transformResponse: (res) => res,
      invalidatesTags: ["BanksDetails"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetBanksByCountryQuery,
  useGetBanksDetailsQuery,
  useResolveAccountMutation,
  useGetLevel2StatusQuery,
  useAddBankMutation,
  useDeleteBankMutation,
  useWithdrawMutation,
} = bankApi;

export default bankApi;
